import { connect } from 'react-redux';
import Store from '../../Store';
import ModuleDPI, { Props } from '../_components/ModuleDPI';

const mapStateToProps = (store:Store, props:Props) => ({
	width: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'width']),
	height: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'height']),
});

export default connect(
	mapStateToProps,
	null
)(ModuleDPI);